import React, { useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from "store/AuthProvider";
import { StoreContext } from "store/StoreProvider";
import { PickemLayoutPage } from "layouts/PickemLayoutPage";
import { PickemTable } from "components/common/Table/PickemTable";
import { headList } from "./model";
import { Link } from "react-router-dom";
import { Spinner } from "components/common/Spinner/Spinner";
import { withDialog } from "components/common/withDialog/withDialog";
import { TextInput } from "components/common/Form/TextInput/TextInput";
import Checkbox from "components/common/Form/Checkbox/Checkbox";
import { Select } from "components/common/Form/Select/Select";
//import { Select } from "components/common/Form/Select/Select";
import Confirmation from "modals/Confirmation";
import { simpleOptions, options } from "utils/helpers";
import "./PickemStandingsPage.scss";
//const CryptoJS = require("crypto-js");

//GetPickset -> know competitor, competition, currentWeek, regular weeks + postseason weeks to build the page

const PickemStandingsPage = ({
    history,
    location,
    openModal,
    closeModal,
    match: {
        params: {
            competitionId
        }

    }
    }) => {
    const { functions, accountData, user } = useContext(AuthContext);
    const { updateMeta, competitionData, updateCompetitionData, version } = useContext(StoreContext);
    const [isLoading, setIsLoading] = useState(true)
    const [standingsDisplayData, setStandingsDisplayData] = useState(null)
    const [standingsData, setStandingsData] = useState({})
    const [nameString, setNameString] = useState(null)
    const [competitionName, setCompetitionName] = useState(null)
    const [competitionDescription, setCompetitionDescription] = useState(null)
    const [currentWeek, setCurrentWeek] = useState(null)
    const [selectedWeek, setSelectedWeek] = useState(null)
    const [isCommissioner, setIsCommissioner] = useState(false)
    const [sortBy, setSortBy] = useState("wins")
    const [sortOrder, setSortOrder] = useState("desc")

    useEffect(() => {
        updateMeta({
            title: "Standings",
        });
    }, []);

    useEffect(() => {
        if (version.isUpdated) {
            confirm("VersionChange")
        }
    }, [version])

    useEffect(() => {
        getStandings(false)
    }, [])

    useEffect(() => {
        analyzeStandingsData()
    }, [standingsData])

    useEffect(() => {
        if (standingsDisplayData && standingsDisplayData.length > 0) {
            setIsLoading(false)
        }
    }, [standingsDisplayData])

    const confirm = (action, compId, compName) => {
        let message = '';
        let title = ''
        switch (action) {
            case 'VersionChange':
                title = 'Updated App Version'
                message = "Refresh Now"
                break
            default:
                title = "Error"
                message = "An Error Has Occurred"
                break
        }
        openModal({
            title: title,
            content: (
                <Confirmation
                    message={message}
                    closeModal={closeModal}
                    buttons={false}
                    onConfirm={() => {
                        closeModal();
                            switch (action) {
                                case 'VersionChange':
                                    window.location.reload()
                                    break
                            }
                    }}
                />
            ),
        });
    };

    const getStandings = (runAllWeeks, weekNumber) => {
        functions.httpsCallable('pickemGetStandingsPage')({
            body: JSON.stringify({
                competitionId: competitionId,
                runAllWeeks: runAllWeeks,
                currentWeek: weekNumber
            })
        }).then((result) => {
            if (result.data.success) {
                setStandingsData(() => result.data.data)
                setCurrentWeek(() => result.data.data.currentWeek)
            }
            else {
                if (result.data.message === "Competitor not in competition") {
                    history.push(`/pickem-join/${competitionId}`)
                }
                setStandingsData({})
            }
        })
    }

    const analyzeStandingsData = () => {
        if (standingsData && Object.keys(standingsData).length > 0) {
            let standingsDataList = []
            for (const key in standingsData.summary) {
                let picksetName = null
                if (standingsData.summary[key].isRandomUser) {
                    picksetName = (<Link name={standingsData.summary[key].picksetName} to={{pathname: `/pickem-picks/${competitionId}`}} onClick={() => updateCompetitionData({picksUserId: key, isRandomUser: true, shownPicksetName: standingsData.summary[key].picksetName})}>
                        {standingsData.summary[key].picksetName}
                    </Link>)
                }
                else {
                    picksetName = (
                        <Link name={standingsData.summary[key].picksetName} to={{pathname: `/pickem-picks/${competitionId}`}} onClick={() => updateCompetitionData({picksUserId: key, isRandomUser: false, shownPicksetName: standingsData.summary[key].picksetName})}>
                            {standingsData.summary[key].picksetName}
                        </Link>
                    )
                }
                let name = ""
                if (standingsData.summary[key].isRandomUser) {
                    name = standingsData.summary[key].randomName
                }
                else {
                    if (standingsData.summary[key].firstName && standingsData.summary[key].lastName) {
                        name = `${standingsData.summary[key].firstName} ${standingsData.summary[key].lastName}`
                    }
                    else if (standingsData.summary[key].firstName) {
                        name = `${standingsData.summary[key].firstName}`
                    }
                    else if (standingsData.summary[key].lastName) {
                        name = `${standingsData.summary[key].lastName}`
                    }
                    else if (standingsData.summary[key].email) {
                        name = `${standingsData[key].email}`
                    }
                }
                const competitorObj = {
                    ...standingsData.summary[key],
                    picksetName: picksetName,
                    name: name,
                    id: key
                }
                standingsDataList.push(competitorObj)
            }
            standingsDataList = standingsSort(standingsDataList, sortBy, sortOrder)
            setStandingsDisplayData(() => standingsDataList.map((item, i) => ({...item, rank: i + 1})))
        }
        else {
            setStandingsDisplayData([])
        }
    }

    const standingsSort = (standingsList, by, order) => {

        if (order === "desc") {
            return standingsList.sort((a,b) => {
                if (b[by] !== a[by]) {
                    if (by === "name") {
                        return ('' + b[by]).localeCompare(a[by]);
                    } 
                    else if (by === "record" || by === "winPercent") {
                        return parseFloat(b["winPercent"]) - parseFloat(a["winPercent"])
                    }
                    else if (by === "pickPercent" || by === "pickMadePercent") {
                        return parseFloat(b[by]) - parseFloat(a[by])
                    }
                    else if (by === "picksRecord") {
                        return parseFloat(b["pickPercent"]) - parseFloat(a["pickPercent"])
                    } else if (by === "picksetName") {
                        return Object(b[by]).props.name.localeCompare(Object(a[by]).props.name)
                    }
                    return parseInt(b[by]) - parseInt(a[by])
                }
    
                if (b.picksRight !== a.picksRight) {
                    return b.picksRight - a.picksRight
                }
    
                if (a.tiebreakerRank !== b.tiebreakerRank) {
                    return a.tiebreakerRank - b.tiebreakerRank
                }
                const week = selectedWeek ? selectedWeek : currentWeek
                let result = 0
                for (let i = week - 1; i > 0; i--) {
                    const weekId = `week_${i.toString().padStart(2, 0)}`
                    if (standingsData.weeks[weekId]) {
                        result = standingsData.weeks[weekId][a.uid].tiebreakerRank - standingsData.weeks[weekId][b.uid].tiebreakerRank
                        if (result != 0) {
                            break
                        }
                    }
                }
                if (result) {
                    return result
                }
    
                return a.joinedAt - b.joinedAt
            })
        } else {
            return standingsList.sort((a,b) => {
                if (b[by] !== a[by]) {
                    if (by === "name") {
                        return ('' + a[by]).localeCompare(b[by]);
                    } 
                    else if (by === "record" || by === "winPercent") {
                        return parseFloat(a["winPercent"]) - parseFloat(b["winPercent"])
                    }
                    else if (by === "pickPercent" || by === "pickMadePercent") {
                        return parseFloat(a[by]) - parseFloat(b[by])
                    }
                    else if (by === "picksRecord") {
                        return parseFloat(a["pickPercent"]) - parseFloat(b["pickPercent"])
                    } else if (by === "picksetName") {
                        return Object(a[by]).props.name.localeCompare(Object(b[by]).props.name)
                    }
                    return parseInt(a[by]) - parseInt(b[by])
                }
    
                if (b.picksRight !== a.picksRight) {
                    return a.picksRight - b.picksRight
                }
    
                if (a.tiebreakerRank !== b.tiebreakerRank) {
                    return b.tiebreakerRank - a.tiebreakerRank
                }
                const week = selectedWeek ? selectedWeek : currentWeek
                let result = 0
                for (let i = week - 1; i > 0; i--) {
                    const weekId = `week_${i.toString().padStart(2, 0)}`
                    if (standingsData.weeks[weekId]) {
                        result = standingsData.weeks[weekId][b.uid].tiebreakerRank - standingsData.weeks[weekId][a.uid].tiebreakerRank
                        if (result) {
                            break
                        }
                    }
                }
                if (result) {
                    return result
                }
    
                return b.joinedAt - a.joinedAt
            })
        }
        
    }

    const sortFunc = (by, order) => {
        setSortBy(by);
        setSortOrder(order);
        setStandingsDisplayData(standingsSort(standingsDisplayData, by, order));
    };

    useEffect(() => {
        let name = ""
        if (accountData.firstName && accountData.lastName) {
            name = `${accountData.firstName} ${accountData.lastName}`
        }
        else if (accountData.firstName) {
            name = `${accountData.firstName}`
        }
        else if (accountData.lastName) {
            name = `${accountData.lastName}`
        }
        else if (user.email) {
            name = `${user.email}`
        }
        setNameString(name)
        if (competitionData.competitionDescription) {
            setCompetitionDescription(competitionData.competitionDescription)
        }
        if (competitionData.competitionName) {
            setCompetitionName(competitionData.competitionName)
        }
        setIsCommissioner(competitionData.isCommissioner === user.uid)
    }, [competitionData])

    const weekClicked = (weekData) => {
        setIsLoading(true)
        getStandings(false, weekData.e.target.value)
        setSelectedWeek(weekData.e.target.value)
    }

    const createWeeks = (numWeeks, isPost) => {
        const weekList = []
        const selected = {}
        for (let weekNumber = 1; weekNumber <= numWeeks; weekNumber++) {
            const weekId = isPost ? weekNumber + standingsData.regWeeks : weekNumber
            const isCurrentWeek = currentWeek === weekId
            selected[weekId] = isCurrentWeek
            weekList.push((<button key={weekId} value={weekId} onClick={e => weekClicked({e, isPost}, "value")} className={`PickemStandingsPage-weekButton ${isCurrentWeek ? "PickemStandingsPage-currentWeek": "PickemStandingsPage-notCurrentWeek"} ${Number(selectedWeek) === weekId ? "PickemStandingsPage-selectedWeek": null}`}>{weekNumber}</button>))
        }
        return weekList
    }

    const RerunStandingsButton = () => {
        return (
            <button style={{ fontSize: "1em", margin: "0.5em", width: "5em" }}
            className={`btn-primary`} onClick={handleUpdateStandings}
        >
            Rerun
        </button>
        )
    }

    const handleUpdateStandings = () => {
        setIsLoading(true)
        functions.httpsCallable('pickemGetStandingsPage')({
            body: JSON.stringify({
                competitionId: competitionId,
                runAllWeeks: true,
                currentWeek: null,
                onlyUpdateStandings: false
            })
        }).then((result) => {
            if (result.data.success) {
                setStandingsData(() => result.data.data)
                setCurrentWeek(() => result.data.data.currentWeek)
            }
            setIsLoading(false)
        })
    }

    return (
        <PickemLayoutPage
            title="Standings"
            name={nameString} competitionName={competitionName} competitionDescription={competitionDescription}
            subtitle={
                <>
                    {
                        isCommissioner ? 
                        <div style={{ display: "flex", fontSize: "1em", justifyContent: "flex-end"}}> 
                                <RerunStandingsButton />                    
                        </div> : null
                    }
                </>
            }
        >
            <div className="PickemStandingsPage">
            <div className="PickemStandingsPage-weekView">
                {!isLoading && standingsData.regWeeks ? <div className="PickemStandingsPage-weeks">
                        <div><p>Regular</p></div>
                        {
                            createWeeks(standingsData.regWeeks, false)
                        }
                </div> : null}
                {!isLoading && standingsData.postWeeks ? <div className="PickemStandingsPage-weeks">
                
                        <div style={{padding: '0.1em'}}><p>Post</p></div>
                        {
                            createWeeks(standingsData.postWeeks, true)
                        }
                </div> : null}
                
            </div>
                {!isLoading && standingsDisplayData ? <PickemTable
                    subject="standings"
                    headList={headList}
                    list={standingsDisplayData}
                    selected={[]}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    sortFunc={sortFunc}></PickemTable> : <Spinner></Spinner>}
                    
            </div>
            
        </PickemLayoutPage>
    );
};

export default withDialog(PickemStandingsPage);
